// src/jira-software/board/types.ts
var JiraSoftwareBoardAriResourceOwner = "jira-software", JiraSoftwareBoardAriResourceType = "board";

export {
  JiraSoftwareBoardAriResourceOwner,
  JiraSoftwareBoardAriResourceType
};
